import React, {useState} from "react";
import Storage from "../../services/storage.service";
import { selectAndSavePlan } from "../../services/plans.service";
import { t } from "../../services/translation.service";
import Spinner from "../../components/spinners/spinner";
import './style.scss';

const PlanDuration = (props) => {
    const [loading, setLoading] = useState(null);
    
    const switch_12month_plan = () => {
        let saved_plan = Storage.get("saved_plan");
        saved_plan.ProductCode = "194";
        setLoading(true);
        selectAndSavePlan(saved_plan);

    }
    const hasBroadbandDevice = Storage.get("saved_plan").Plans.some(plan => plan.Type === "BroadbandDevice");

    return (
        <>
        <div className="vmo-plan-spec summary-plan-duration">
            {props.duration===1 ? t("SUMMARY_PLAN_DURATION_1"): t('SUMMARY_PLAN_DURATION_12')}
        </div>
        {props.duration===1 && hasBroadbandDevice ?
            loading? <Spinner size="small"/> :
            <div className="summary-plan-switch-12-months">
                <div>
                    <div className="switch-12-months-label-1"
                    onClick={switch_12month_plan}>
                        {t("SUMMARY_PLAN_UNLOCK_DISCOUNT_LABEL1")}</div>
                    <div className="switch-12-months-label-2">
                        {t("SUMMARY_PLAN_UNLOCK_DISCOUNT_LABEL2")}</div>
                </div>
            </div>
        : ''}
        </>
    )
}
export default PlanDuration;